import { debounce } from "es-toolkit";
import type { ChangeEvent } from "react";
import { useEffect, useMemo, useState } from "react";

export const useDebounceInputLogic = ({
  value,
  setValue,
}: {
  value: string;
  setValue: (term: string) => void;
}) => {
  const [inputValue, setInputValue] = useState(value);

  const debouncedSetSearchTerm = useMemo(
    () =>
      debounce((value: string) => {
        setValue(value);
      }, 300),
    [setValue],
  );

  useEffect(() => {
    return () => {
      debouncedSetSearchTerm.cancel();
    };
  }, []);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value);
    debouncedSetSearchTerm(value);
  };

  return {
    debouncedSetSearchTerm,
    inputValue,
    handleInputChange,
    setInputValue,
  };
};
